export const iconFontAwesomeMedicalHealthHospitalUser = (
	<i className="fa-solid fa-hospital-user"></i>
);
